/**
 * Best-effort secret redaction applied to every chunk before it can leave the
 * machine (e.g. shipped to an embedding vendor or the gateway). This complements
 * — does not replace — ignoring secret-bearing files entirely (see ignore.ts).
 * A real deployment should additionally run a gitleaks/trufflehog ruleset.
 */
const SECRET_PATTERNS: ReadonlyArray<RegExp> = [
  /AKIA[0-9A-Z]{16}/g, // AWS access key id
  /\bsk-[A-Za-z0-9]{20,}\b/g, // OpenAI-style secret keys
  /\bgh[pousr]_[A-Za-z0-9]{20,}\b/g, // GitHub tokens
  /-----BEGIN (?:RSA |EC |OPENSSH |DSA |PGP )?PRIVATE KEY-----[\s\S]*?-----END (?:RSA |EC |OPENSSH |DSA |PGP )?PRIVATE KEY-----/g,
  /\beyJ[A-Za-z0-9_-]{10,}\.[A-Za-z0-9_-]{10,}\.[A-Za-z0-9_-]{10,}\b/g, // JWT
  /\b(?:postgres(?:ql)?|mysql|mongodb(?:\+srv)?|redis|amqps?):\/\/[^\s'"]*:[^\s'"@/]+@[^\s'"]+/gi, // conn string with inline creds
  /\b(?:password|passwd|secret|api[_-]?key|access[_-]?key|auth[_-]?token)\b\s*[:=]\s*['"][^'"\n]{6,}['"]/gi, // assigned literal secrets
];

const PLACEHOLDER = '«redacted-secret»';

export function redactSecrets(text: string): { text: string; redacted: number } {
  let redacted = 0;
  let out = text;
  for (const re of SECRET_PATTERNS) {
    out = out.replace(re, () => {
      redacted += 1;
      return PLACEHOLDER;
    });
  }
  return { text: out, redacted };
}
